import React from "react";
import "./BifurcatedPromo.css";

interface PromoSide {
  title: string;
  description?: string;
  bullets?: string[];
  image?: string;
}

interface BifurcatedPromoProps {
  id?: string;
  title: string;
  left: PromoSide;
  right: PromoSide;
  variant?: string;
}

export const BifurcatedPromo: React.FC<BifurcatedPromoProps> = ({
  id,
  title,
  left,
  right
}) => {

  const renderContent = (side: PromoSide) => {

    // If explicit bullets exist
    if (side.bullets && side.bullets.length > 0) {
      return (
        <ul className="promo-bullets">
          {side.bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      );
    }

    // Convert description paragraphs into bullets
    if (side.description) {
      const lines = side.description
        .split("\n")
        .map(l => l.trim())
        .filter(l => l.length > 0);

      return (
        <ul className="promo-bullets">
          {lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      );
    }

    return null;
  };

  return (
    <section id={id} className="bifurcated-promo">

      <h2 className="promo-title">{title}</h2>

      <div className="promo-content">

        {/* LEFT SIDE */}
        <div className="promo-left">
          {left.image && <img src={left.image} alt={left.title} />}
        </div>

        {/* RIGHT SIDE */}
        <div className="promo-right">
          <h3>{right.title}</h3>
          {renderContent(right)}
        </div>

      </div>

    </section>
  );
};